export const ToolsHandle =
{
    time:0,
    getKeyObj(e)
    {
        var delayTime = this.time == 0 ? 0 : Math.round(e.timeStamp - this.time);
        this.time = e.timeStamp;

        var keyName;

        switch(e.keyCode)
        {
            case 96:
                keyName = '0';
                break;
            case 97:
                keyName = '1';
                break;
            case 98:
                keyName = '2';
                break;
            case 99:
                keyName = '3';
                break;
            case 100:
                keyName = '4';
                break;
            case 101:
                keyName = '5';
                break;
            case 102:
                keyName = '6';
                break;
            case 103:
                keyName = '7';
                break;
            case 104:
                keyName = '8';
                break;
            case 105:
                keyName = '9';
                break;
            case 112:
                keyName = 'F1';
                break;
            case 113:
                keyName = 'F2';
                break;
            case 114:
                keyName = 'F3';
                break;
            case 115:
                keyName = 'F4';
                break;
            case 116:
                keyName = 'F5';
                break;
            case 117:
                keyName = 'F6';
                break;
            case 118:
                keyName = 'F7';
                break;
            case 119:
                keyName = 'F8';
                break;
            case 120:
                keyName = 'F9';
                break;
            case 121:
                keyName = 'F10';
                break;
            case 122:
                keyName = 'F11';
                break;
            case 123:
                keyName = 'F12';
                break;
            case 9:
                keyName = 'Tab';
                break;
            case 16:
                keyName = 'LSHIFT';
                break;
            case 17:
                keyName = 'LCTRL';
                break;
            case 18:
                keyName = 'LALT';
                break;
            case 91:
                keyName = 'LWIN';
                break;
            case 20:
                keyName = 'CapsLock';
                break;
            case 32:
                keyName = 'Space';
                break;
            case 33:
                keyName = 'Page Up';
                break;
            case 34:
                keyName = 'Page Down';
                break;
            case 35:
                keyName = 'End';
                break;
            case 36:
                keyName = 'Home';
                break;
            case 37:
                keyName = 'Left';
                break;
            case 38:
                keyName = 'Up';
                break;
            case 39:
                keyName = 'Right';
                break;
            case 40:
                keyName = 'Down';
                break;
            case 45:
                keyName = 'Insert';
                break;
            case 46:
                keyName = 'Delete';
                break;
            case 144:
                keyName = 'Num Lock';
                break;
            case 111:
                keyName = 'Num /';
                break;
            case 106:
                keyName = 'Num *';
                break;
            case 107:
                keyName = 'Num +';
                break;
            case 109:
                keyName = 'Num -';
                break;
            case 13:
                keyName = 'Enter';
                break;
            case 110:
                keyName = 'Num .';
                break;
            case 27:
                keyName = 'Esc';
                break;
            case 192:
                keyName = '`';
                break;
            case 189:
                keyName = '-';
                break;
            case 187:
                keyName = '=';
                break;
            case 219:
                keyName = '[';
                break;
            case 221:
                keyName = ']';
                break;
            case 220:
                keyName = '\\';
                break;
            case 186:
                keyName = ';';
                break;
            case 222:
                keyName = "'";
                break;
            case 188:
                keyName = ',';
                break;
            case 190:
                keyName = '.';
                break;
            case 191:
                keyName = '/';
                break;
            case 8:
                keyName = 'BackSpace';
                break;
            case 44:
                keyName = 'PrintScreen';
                break;
            case 145:
                keyName = 'ScrollLock';
                break;
            case 19:
                keyName = 'Pause';
                break;
            case 93:
                keyName = 'Menu';
                break;
            default :
                keyName = String.fromCharCode(e.keyCode);
                break;
        }

        if (e.type == 'mousedown' || e.type == 'mouseup') {
            switch (e.button) {
                case 0:
                    keyName = sInfo['leftkey'];
                    e.keyCode = 1;
                    break;
                case 1:
                    keyName = sInfo['middlekey'];
                    e.keyCode = 4;
                    break;
                case 2:
                    keyName = sInfo['rightkey'];
                    e.keyCode = 2;
                    break;
            }
        }

        return {'keyCode':e.keyCode,'keyName':keyName,'delayTime':delayTime};
    },
    delay(ms) 
    {  
      return new Promise(resolve => setTimeout(resolve, ms));  
    },
    stringToASCII(str) 
    {
        let asciiArr = [];
        for (let i = 0; i < str.length; i++) {
          let ascii = str.charCodeAt(i);
          asciiArr.push(ascii.toString(16));
        }
        return asciiArr;
    },
    getLanguage()
    {
        let curLang = "en";
        let defaultLang = 'en';
        let sysLang = navigator.language;
        let setLang = localStorage.getItem('language');

        if(setLang == null)
        {
            switch (sysLang) 
            {
                case "zh":
                case "zh-CN":
                curLang = 'zh';
                break;
                case "en":
                case "en-US":
                case "en-GB":
                curLang = 'en';
                break;
                case "ja":
                case "ja-JP":
                curLang = 'jp';
                break;
                default:
                curLang = 'en';
                break;
            }
        }
        else
        {
            curLang = setLang;
        }

        console.log(curLang);

        return curLang;
    },
    isBrowserSupportHid()
    {
        if ("hid" in navigator)
        {
            return true;
        }
        else
        {
            return false;
        }
    }
}